import type { Response } from '../response';
import { get } from '../fetch-extension';
import type { L10N } from '@/ontology/i18n';

//tells the server what our locale is.. result is discarded
export default async function localize(language: string): Promise<Response<any>> {
    return await get<any>('localize', { query: { language } });
}
